import type { uuid } from "@/interfaces";
import { api } from "@/lib/api";
import type { ListedServicePrice, PropertyPrice } from "@shyne/shared/api";

export type PropertyPriceRow = { id: string; service: uuid; price: number; payment: number };

export type PropertyPriceSetting = { service: uuid; price: number; payment: number };

const toRow = ({ id, service, price, pay }: PropertyPrice): PropertyPriceRow => ({ id, service: service.id, price, payment: pay ?? 0 });

export const VendorPropertyServicePricingRepository = {
  async listAt(propertyId: uuid, vendorId: uuid): Promise<PropertyPriceRow[]> {
    const { items } = await api.propertyPrices.list(propertyId, { actingOrganization: vendorId, vendor: vendorId });
    return items.map(toRow);
  },

  async replaceAt(propertyId: uuid, vendorId: uuid, prices: readonly PropertyPriceSetting[]): Promise<PropertyPriceRow[]> {
    const { items } = await api.propertyPrices.set(propertyId, {
      actingOrganization: vendorId,
      prices: prices.map(({ service, price, payment }) => ({ service, price, pay: payment })),
    });
    return items.map(toRow);
  },

  listedAt(propertyId: uuid, vendorId: uuid, serviceId: uuid): Promise<ListedServicePrice> {
    return api.propertyPrices.listed(propertyId, { actingOrganization: vendorId, service: serviceId });
  },
};
